import React from "react";
import { Link } from "react-router-dom";
import haystack from "../../images/hay26.png"

const Heading = () => {
    return (
        <div className="flex justify-center items-center flex-col px-4 sm:px-6 py-6">
            <Link to='/'>
                <img
                    src={haystack}
                    alt="Haystack illustration"
                    className="h-24 sm:h-32 md:h-36 lg:h-40 object-contain"
                />
            </Link>
            <h1 className="font-clashMedium text-center text-lg sm:text-2xl my-4 max-w-3xl">
                Stirring the hearts of men for the work of missions
            </h1>
        </div>
    );
};

export default Heading;
